import {Iterable} from 'immutable';


export default function isIterable (obj) {
  return Iterable.isIterable(obj);
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/immutable/isIterable.js